export default function checkIfCanSeeCompanyQuestionnaireRoutes({ next, store }) {
  let scopes = store.getters.userScopes;
  let exists = scopes.includes('questionnaire_list') || scopes.includes('questionnaire_company');
  return exists ? next() : next({ name: 'dashboard' });
}
